export const openLink = (link) =>{
    window.open(link)
  }